import { apiRequest } from './auth'
import type { RecordKey } from '../data/clientRecords'

type ApiEnvelope<T> = { data: T; meta: { requestId: string } }

export type ClientRecord = {
  id: string
  section: RecordKey
  values: string[]
  version: number
  createdAt: string
  updatedAt: string
}

export async function listClientRecords(clientId: string, section?: RecordKey): Promise<ClientRecord[]> {
  const suffix = section ? `?section=${encodeURIComponent(section)}` : ''
  const response = await apiRequest<ApiEnvelope<ClientRecord[]>>(
    `clients/${encodeURIComponent(clientId)}/records${suffix}`,
  )
  return response.data
}

export type ClientAuditEvent = {
  id: string
  action: string
  entityType?: string
  entityId?: string
  actorUserId?: string
  reason?: string
  occurredAt: string
}

export async function listClientAuditEvents(clientId: string): Promise<ClientAuditEvent[]> {
  const response = await apiRequest<ApiEnvelope<ClientAuditEvent[]>>(
    `clients/${encodeURIComponent(clientId)}/audit-events`,
  )
  return response.data
}

export async function createClientRecord(clientId: string, section: RecordKey, values: string[]): Promise<ClientRecord> {
  const response = await apiRequest<ApiEnvelope<ClientRecord>>(`clients/${encodeURIComponent(clientId)}/records`, {
    method: 'POST',
    body: JSON.stringify({ section, values }),
  })
  return response.data
}

export async function updateClientRecord(clientId: string, record: ClientRecord, values: string[]): Promise<ClientRecord> {
  const response = await apiRequest<ApiEnvelope<ClientRecord>>(
    `clients/${encodeURIComponent(clientId)}/records/${record.id}`,
    { method: 'PATCH', body: JSON.stringify({ values, version: record.version }) },
  )
  return response.data
}

export async function deleteClientRecord(clientId: string, recordId: string): Promise<void> {
  await apiRequest(`clients/${encodeURIComponent(clientId)}/records/${recordId}`, { method: 'DELETE' })
}
